// İSG uzmanı portalı — Yöntem işareti. `DayListTab.tsx`'in "Bugün" panosu (S32b §4.1) VE
// `VerdictCard.tsx`'in karar kartının kimlik satırı (`docs/reviews/S32c-gate-desk-polish.md`
// §2.2 Option A) AYNI sözcük dağarcığını paylaşır — bu yüzden ayrı bir dosyaya çekildi (tek
// yerde tanımlı, iki tüketici). İkon + sözcük — RENK TEK BAŞINA anlam TAŞIMAZ (K8/§6).
//
// **`selfAssertedSuffix` (S32d `docs/reviews/S32d-verdict-and-detail.md` §3.1) — YALNIZ karar
// kartının kimlik satırı kullanır.** `GateQr` yolu personelin KENDİ BEYANIDIR (api-contract §6,
// `VerdictCard.tsx` dosya başı notu) — kararın YANINDA bu ayrımı yeniden yazmak yerine paylaşılan
// bileşene bir PROP eklendi (ikinci bir yöntem rozeti İCAT EDİLMEDİ). `DayListTab.tsx` bu propu
// hiç geçmez (varsayılan `false`) — o satırın kendi genel açıklaması zaten panel altbilgisinde
// var (`security.day.methodDisclaimer`), tek tek rozette tekrar gerekmiyor.

import type { SecurityEntryMethod } from '@isgportal/shared';
import { cn } from '@isgportal/shared';
import { QrCode, ShieldCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function MethodMarker({
  method,
  selfAssertedSuffix = false,
  className,
}: {
  method: SecurityEntryMethod;
  /** `GateQr` iken sözcüğe "(kendi beyanı)" ekler (S32d §3.1) — diğer yöntemlerde etkisizdir. */
  selfAssertedSuffix?: boolean;
  className?: string;
}) {
  const { t } = useTranslation();
  if (method === 'GateQr') {
    return (
      <span
        className={cn('inline-flex items-center gap-1.5 text-xs font-medium text-muted', className)}
      >
        <QrCode className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
        {selfAssertedSuffix
          ? t('security.method.gateQr.selfAsserted')
          : t('security.method.gateQr')}
      </span>
    );
  }
  return (
    <span
      className={cn('inline-flex items-center gap-1.5 text-xs font-medium text-muted', className)}
    >
      <ShieldCheck className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      {method === 'TcLookup' ? t('security.method.tcLookup') : t('security.method.personnelQr')}
    </span>
  );
}
